import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { PreferencesProvider } from './contexts/PreferencesContext';
import { AlertSettingsProvider } from './contexts/AlertSettingsContext';
import './styles.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <PreferencesProvider>
      <AlertSettingsProvider>
        <App />
      </AlertSettingsProvider>
    </PreferencesProvider>
  </React.StrictMode>
);
